// extracted by mini-css-extract-plugin
export var cancelButton = "_ov-5";
export var content = "_ov-3";
export var createButton = "_ov-6";
export var drawerContainer = "_ov-0";
export var footer = "_ov-2";
export var header = "_ov-1";
export var orderFormColumn = "_ov-4";